










import { Component, Vue } from 'vue-property-decorator';
import { TokenUser } from '../TokenUser'
import * as utils from '../utils';
import * as utils_tracker from '../utils_tracker';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src


@Component({
  name: 'ForgotPassword',
  components: { ModalWrapperComponent }
})
export default class ForgotPasswordView extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public code: string

  public get loading(): boolean { return this.$store.state.loading }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }

  // public functions available to the html template

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    // get code from URL
    this.code = this.$route.params.code

    // send to server to verify this user's email address and see if registration needs to be completed still (invited user)
    await this.fetchData()
  }

private async fetchData(): Promise<void> {

    this.$store.commit('setLoading', { loading: true });
    try {
        let url: string = utils.getURLprefix() + '/api/auth/checkForgottenPasswordCode'
        url += `?code=${this.code}`
        const response: any = await utils.makeGetCall(url);

        // error check
        if (response.data.error) {
          this.$store.commit('setLoading', { loading: false });
          try { await this.$router.push({ name: 'home', params: { title: 'Error', msg: response.data.error }}) } catch (Error) {}
          return
        }

        // code worked
        if (response.data.user) {
          const user: TokenUser = new TokenUser(response.data.user);
          user.email = response.data.email;
          (this.$refs.ResetToNewPasswordFormComponent as ModalWrapperComponent).show('Choose a new password', 'sm', { fwPasswordCode: this.code, preFilledUser: user } )
        }

    } catch (error) {
      utils.toast(this, 'Error', 'Could not confirm code')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }


  }

}

